import Vue from 'vue'
import VueRouter from 'vue-router'
import { Store } from 'vuex'
import { RootState } from '../store/rootState'

import pdvVendas from '../views/pdv/vendas.vue'
import pdvRelatorios from '../views/pdv/relatorios.vue'
import pdvCategorias from '../views/pdv/categorias.vue'
import pdvProdutos from '../views/pdv/produtos.vue'
import pdvEstoque from '../views/pdv/estoque.vue'
import pdvAcessoNegado from '../views/pdv/acesso-negado.vue'
import cardapioPublico from '../views/publico/cardapio.vue'
import manutencao from '../views/dashboard/manutencao.vue'
import rhDashboard from '../views/rh_dashboard.vue'
import rhEstrutura from '../views/rh_estrutura.vue'
import rhDiagnostico from '../views/rh_diagnostico.vue'
import rhConfiguracao from '../views/rh_configuracao.vue'
import rhDesenvolvimento from '../views/rh_desenvolvimento.vue'
import rhPessoas from '../views/rh_pessoas.vue'
import rhPerfil from '../views/rh_perfil.vue'
import rhColaborador from '../views/rh_colaborador.vue'
import rhAgenda from '../views/rh_agenda.vue'
import rhAceitarConvite from '../views/rh_aceitar_convite.vue'
import rhRecuperar from '../views/rh_recuperar.vue'
import rhRedefinir from '../views/rh_redefinir.vue'
import eadArea from '../views/ead/ead-area.vue'
import eadMeusCursos from '../views/ead/ead-meus-cursos.vue'
import eadCursoPlayer from '../views/ead/ead-curso-player.vue'
import eadAvaliacao from '../views/ead/ead-avaliacao.vue'
import eadCursos from '../views/ead/ead-cursos.vue'
import eadCursoCadastro from '../views/ead/ead-curso-cadastro.vue'
import eadCursoConteudo from '../views/ead/ead-curso-conteudo.vue'
import eadAvaliacaoConteudo from '../views/ead/ead-avaliacao-conteudo.vue'
import eadLiberacoes from '../views/ead/ead-liberacoes.vue'
import eadRelatorio from '../views/ead/ead-relatorio-progresso.vue'
import eadDashboardAdmin from '../views/ead/ead-dashboard-admin.vue'
import eadProgressoDetalhe from '../views/ead/ead-progresso-detalhe.vue'
import eadValidarCertificado from '../views/ead/ead-validar-certificado.vue'

import funcionario from '../views/cadastro/funcionario.vue'
import unidade from '../views/cadastro/unidade.vue'
import niveldeacesso from '../views/cadastro/niveldeacesso.vue'
import funcionarios from '../views/lista/funcionarios.vue'
import unidades from '../views/lista/unidades.vue'
import niveisDeAcessoVue from '../views/lista/niveisdeacesso.vue'
const Sobre = () => import('../views/sobre.vue')

export function installVue2Router() {
    Vue.use(VueRouter)
}

const routes = [
	{
		path: '/rh/aceitar',
		name: 'rh-aceitar-convite',
		component: rhAceitarConvite,
		meta: { publico: true }
	},
	{ path: '/rh/recuperar', name: 'rh-recuperar', component: rhRecuperar, meta: { publico: true } },
	{ path: '/rh/redefinir', name: 'rh-redefinir', component: rhRedefinir, meta: { publico: true } },
	{
		path: '/rh',
		name: 'rh-dashboard',
		component: rhDashboard,
		meta: { roles: ['rh-diretoria', 'rh-lider', 'rh-colaborador'] }
	},
	{
		path: '/rh/estrutura',
		name: 'rh-estrutura',
		component: rhEstrutura,
		meta: { roles: ['rh-diretoria', 'rh-lider'] }
	},
	{
		path: '/rh/diagnostico',
		name: 'rh-diagnostico',
		component: rhDiagnostico,
		meta: { roles: ['rh-diretoria', 'rh-lider', 'rh-colaborador'] }
	},
	{
		path: '/rh/configuracao',
		name: 'rh-configuracao',
		component: rhConfiguracao,
		meta: { roles: ['rh-diretoria'] }
	},
	{
		path: '/rh/desenvolvimento',
		name: 'rh-desenvolvimento',
		component: rhDesenvolvimento,
		meta: { roles: ['rh-diretoria', 'rh-lider', 'rh-colaborador'] }
	},
	{
		path: '/rh/cursos',
		component: eadArea,
		children: [
			{ path: '', redirect: { name: 'ead-meus-cursos' } },
			{ path: 'meus', name: 'ead-meus-cursos', component: eadMeusCursos, meta: { roles: ['rh-diretoria', 'rh-lider', 'rh-colaborador'] } },
			{ path: 'meus/:id', name: 'ead-curso-player', component: eadCursoPlayer, meta: { roles: ['rh-diretoria', 'rh-lider', 'rh-colaborador'] } },
			{ path: 'avaliacoes/:id', name: 'ead-avaliacao', component: eadAvaliacao, meta: { roles: ['rh-diretoria', 'rh-lider', 'rh-colaborador'] } },
			{ path: 'cadastros', name: 'ead-cursos', component: eadCursos, meta: { roles: ['rh-diretoria'] } },
			{ path: 'cadastros/curso/:id?', name: 'ead-curso-cadastro', component: eadCursoCadastro, meta: { roles: ['rh-diretoria'] } },
			{ path: 'cadastros/curso/:id/conteudo', name: 'ead-curso-conteudo', component: eadCursoConteudo, meta: { roles: ['rh-diretoria'] } },
			{ path: 'cadastros/curso/:id/avaliacao', name: 'ead-avaliacao-conteudo', component: eadAvaliacaoConteudo, meta: { roles: ['rh-diretoria'] } },
			{ path: 'acessos', name: 'ead-liberacoes', component: eadLiberacoes, meta: { roles: ['rh-diretoria'] } },
			{ path: 'relatorios', name: 'ead-relatorio', component: eadRelatorio, meta: { roles: ['rh-diretoria'] } },
			{ path: 'relatorios/painel', name: 'ead-dashboard-admin', component: eadDashboardAdmin, meta: { roles: ['rh-diretoria'] } },
			{ path: 'relatorios/progresso/:id', name: 'ead-progresso-detalhe', component: eadProgressoDetalhe, meta: { roles: ['rh-diretoria'] } },
		],
	},
	{ path: '/rh/certificados/validar/:codigo?', name: 'ead-validar-certificado', component: eadValidarCertificado, meta: { publico: true } },
	{
		path: '/rh/pessoas',
		name: 'rh-pessoas',
		component: rhPessoas,
		meta: { roles: ['rh-diretoria', 'rh-lider'] }
	},
	{
		path: '/rh/pessoas/perfis/novo',
		name: 'rh-perfil-novo',
		component: rhPerfil,
		meta: { roles: ['Administrador'] }
	},
	{
		path: '/rh/pessoas/perfis/:id(\\d+)/editar',
		name: 'rh-perfil-editar',
		component: rhPerfil,
		meta: { roles: ['Administrador'] }
	},
	{
		path: '/rh/pessoas/novo',
		name: 'rh-colaborador-novo',
		component: rhColaborador,
		meta: { roles: ['rh-diretoria', 'rh-lider'] }
	},
	{
		path: '/rh/pessoas/:id(\\d+)/editar',
		name: 'rh-colaborador-editar',
		component: rhColaborador,
		meta: { roles: ['rh-diretoria', 'rh-lider'] }
	},
	{
		path: '/rh/agenda',
		name: 'rh-agenda',
		component: rhAgenda,
		meta: { roles: ['rh-diretoria', 'rh-lider'] }
	},
	{
		path: '/cardapio',
		name: 'cardapio-publico-query',
		component: cardapioPublico,
		meta: { publico: true }
	},
	{
		path: '/cardapio/:unidade',
		name: 'cardapio-publico',
		component: cardapioPublico,
		meta: { publico: true }
	},
	{
		path: '/cardapio=:unidade',
		name: 'cardapio-publico-legado',
		component: cardapioPublico,
		meta: { publico: true }
	},
	{
		name: 'manutencao',
		path: '/manutencao',
		component: manutencao,
		meta: {
			roles: ["menu-manutencao"]
		}
	},
	{
		name: 'funcionarios',
		path: '/manutencao/funcionarios',
		component: funcionarios,
		meta: {
			roles: ["funcionario-consultar"]
		}
	},
	{
		name: 'funcionario',
		path: '/manutencao/funcionario',
		component: funcionario,
		meta: {
			roles: ["funcionario-alterar"]
		}
	},
	{
		name: 'unidades',
		path: '/manutencao/unidades',
		component: unidades,
		meta: {
			roles: ["unidade-consultar", "unidade-alterar"]
		}
	},
	{
		name: 'unidade',
		path: '/manutencao/unidade',
		component: unidade,
		meta: {
			roles: ["unidade-consultar", "unidade-alterar"]
		}
	},
	{
		name: 'niveisdeacesso',
		path: '/manutencao/niveisdeacesso',
		component: niveisDeAcessoVue,
		meta: {
			roles: ["Administrador"]
		}
	},  
	{
		name: 'niveldeacesso',
		path: '/manutencao/niveldeacesso',
		component: niveldeacesso,
		meta: {
			roles: ["Administrador"]
		}
	},   
	{
		name: 'niveisdeacesso',
		path: '/manutencao/niveisdeacesso',
		component: niveisDeAcessoVue,
		meta: {
			roles: ["Administrador"]
		}
	},       
	{
		path: '/',
		name: 'Sobre',
		component: Sobre,
		meta: {
			autenticado: true
		}
	},
    {
        path: '/pdv/vendas',
        name: 'pdv-vendas',
        component: pdvVendas,
        meta: { roles: ['pdv-vendas-consultar', 'pdv-vendas-realizar'] }
    },
    {
        path: '/pdv/relatorios',
        name: 'pdv-relatorios',
        component: pdvRelatorios,
        meta: { roles: ['pdv-relatorios-consultar'] }
    },
    {
        path: '/pdv/categorias',
        name: 'pdv-categorias',
        component: pdvCategorias,
        meta: { roles: ['pdv-categorias-consultar', 'pdv-categorias-alterar'] }
    },
    {
        path: '/pdv/produtos',
        name: 'pdv-produtos',
        component: pdvProdutos,
        meta: { roles: ['pdv-produtos-consultar', 'pdv-produtos-alterar'] }
    },
    {
        path: '/pdv/estoque',
        name: 'pdv-estoque',
        component: pdvEstoque,
        meta: { roles: ['pdv-estoque-consultar', 'pdv-estoque-movimentar'] }
    },
    {
        path: '/acesso-negado',
        name: 'pdv-acesso-negado',
        component: pdvAcessoNegado,
        meta: { autenticado: true }
    },
    { path: '*', redirect: '/' }
]

export function createVue2Router(store: Store<RootState>) {
    const router = new VueRouter({
        mode: 'history',
        base: process.env.BASE_URL,
        routes,
        linkActiveClass: 'is-active'
    })

    const storeInit = store.dispatch('init')

    router.beforeEach(async (to, from, next) => {
        try {
            if (to.matched.some(record => record.meta && record.meta.publico)) {
                next()
                return
            }

            await storeInit

            if (!store.state.usuario.id) {
                next()
                return
            }

            if (to.meta && to.meta.autenticado) {
                next()
                return
            }

            const regras = store.state.usuario.regras || []
            const roles = to.matched.reduce((lista: string[], record) => lista.concat((record.meta && record.meta.roles) || []), [])
            const permitido = roles.some(role => regras.includes(role))

            if (permitido) {
                next()
                return
            }

            next({ name: 'pdv-acesso-negado' })
        } catch (error) {
            console.error(error)
            next(false)
        }
    })

    return router
}
